import Button from "@components/Button"
import { styled, theme } from "@theme/stitches.config"

export const PositionWrapper = styled("div", {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "flex-end",
    gap: 30
})

export const Position = styled("div", {
    display: "flex",
    width: "100%",
    height: "100%",
    maxHeight: 240,
    border: `1px solid ${theme.colors.effieGold}`,
    borderRadius: 6,
    gap: 30,
    p: 20,
    justifyContent: "space-between",
    flexDirection: "row-reverse",
    "@mdUp": {
        p: 30,
        flexDirection: "row",
        justifyContent: "normal"
    },
    "@lgUp": {
        flexBasis: "calc(50% - 30px)",
        "&:not(:first-child)": {
            mt: 0
        }
    }
})

export const StyledImage = styled("div", {
    display: "flex",
    flexShrink: 0,
    "& img": {
        borderRadius: 6,
        display: "block",
        width: "100%",
        height: "auto",
        maxHeight: 140,
        objectFit: "contain"
    },
    "@mdUp": {
        "& img": {
            maxHeight: 180
        }
    }
})

export const Info = styled("div", {
    display: "flex",
    flexDirection: "column",
    "@mdUp": {
        my: 20
    }
})

export const Title = styled("p", {
    fontSizePxToRem: 20,
    fontWeight: theme.fontWeights.semiBold,
    "@mdUp": {
        fontSizePxToRem: 24
    }
})

export const JobFunction = styled("p", {
    fontSizePxToRem: 16,
    fontWeight: theme.fontWeights.medium,
    color: theme.colors.effieGold,
    mt: 10,
    "@mdUp": {
        fontWeight: theme.fontWeights.semiBold,
        mt: 5
    },
    "@smDown": {
        fontSizePxToRem: 12,
        mt: 0
    }
})

export const ButtonWrapper = styled("div", {
    mt: "auto"
})

export const StyledButton = styled(Button, {
    backgroundColor: theme.colors.backgroundInverse
})
